// extracted by mini-css-extract-plugin
export default {"btn":"Button2_btn__hJWc5"};